<template>
  <v-layout align-center justify-center row fill-height class="ma-0 grey lighten-1">
    <v-card>
      <v-card-title>
        <h2 class="text-h4">Logged Out</h2>
      </v-card-title>
      <v-card-text>
        <p class="text-xs-center">You have been successfully logged out.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="signIn()" block text>
          Log in
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from 'vue-property-decorator';

import auth from '@/services/auth';

@Component({
  components: {},
})

export default class LoggedOut extends Vue {
  private show = true;
  
  private signIn(): void {
    auth.signIn();
  }
}
</script>